import { FormControl, TextField } from "@mui/material";
import React from "react";
import WalkInFormLabel from "./WalkInFormLabel";
import WalkInHelperText from "./WalkInHelperText";

function WalkInFormControlTextField({
  labelName,
  name,
  placeholder,
  handleBlur,
  handleChange,
  errors,
  helperText,
  value,
  type = "text",
}) {
  return (
    <FormControl fullWidth>
      <WalkInFormLabel labelName={labelName} />
      <TextField
        name={name}
        type={type}
        placeholder={placeholder}
        fullWidth
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      />
      <WalkInHelperText helperText={helperText} errors={errors} />
    </FormControl>
  );
}

export default WalkInFormControlTextField;
